import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

const ellipsis = `
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DetailLeftContainer = styled.div`
  flex: 1;
  word-break: break-word;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing[4]};
`;

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})`
  ${ellipsis}
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  -webkit-line-clamp: 3;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    -webkit-line-clamp: 2;
  }
`;

export const SubTitle = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})`
  ${ellipsis}
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
  -webkit-line-clamp: 2;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    -webkit-line-clamp: 1;
  }
`;

export const Time = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})`
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
`;
